import Cookies from "js-cookie";

export const clearCookiesAndRedirect = () => {
  Cookies.remove("token");
  window.location.href = "/sign-in";
};
